module.exports = __webpack_public_path__ + "img/JobOpportunities.11317eff.svg";